/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *
 */
//@ts-nocheck
import React, { useState, useRef } from 'react';
import Badge from 'react-bootstrap/Badge';
import { XCircleIcon, PlusIcon } from '@heroicons/react/solid';
import { NavDropdown, Card, Button, Form } from 'react-bootstrap';
import { useViewport } from '@vlinder-web/viewport-provider-react';
import { CardInput } from './components';
import * as S from './styles';

export interface ISearchFilterProps {
  tableHeaders: {
    key: string;
    filterTypes: string[];
  }[];
  onFilterApply?(filtersData: any): void;
  onClearFilter?(): void;
  buttons: {
    key: string;
    variant: 'light' | 'secondary' | 'primary' | 'success' | 'info' | 'danger';
    title: string;
  }[];
}

export const SearchFilter = (props: ISearchFilterProps) => {
  const { tableHeaders, buttons, onFilterApply, onClearFilter } = props;
  const [selectedFilter, setSelectedFilter] = useState<string>();
  const [filters, setFilters] = useState<array>([]);
  const [autoClose, setAutoClose] = useState(false);
  const { bp } = useViewport();
  const onFilterTypeSelect = (item: string) => {
    setSelectedFilter(item);
  };

  const onApplyFilter = (values: any) => {
    console.log(`applied filters`, values);
    document.getElementById('container')?.click();
    let _temp: any = [];
    let _tempFilters = [...filters];
    if (_tempFilters)
      // if (_tempFilters?.find((item) => item?.key === selectedFilter)) {
      //   _tempFilters?.map((item: any, i: number) => {
      //     if (item?.key === selectedFilter) {
      //       return {
      //         ...item,
      //         filters: values,
      //       };
      //     } else return { ..._tempFilters };
      //   });
      // } else {
      _temp.push({
        key: selectedFilter,
        filters: values,
      });
    // }

    setFilters([..._tempFilters, ..._temp]);
  };

  const onFormFilter = () => {
    document.getElementById('container')?.click();
  };

  const _getCardInput = (filterTypes: any) => {
    if (!autoClose) {
      return (
        <CardInput
          onApplyFilter={onApplyFilter}
          filterTypes={filterTypes}
          onClear={onFormFilter}
        />
      );
    }
  };

  const onFilterRemove = (item: any) => {
    const _tempFilters = filters;
    let _temp =
      Array.isArray(_tempFilters) &&
      _tempFilters.filter((ele: any) => ele?.key !== item?.key);
    console.log(`_temp`, _temp);
    if (_temp && _temp?.length > 0) {
      setFilters(_temp);
      onFilterApply && onFilterApply(_temp);
    } else {
      setFilters(_temp);
      onClearFilter && onClearFilter();
    }
  };

  const onButtonClick = (key: string) => {
    if (key === 'apply') {
      onFilterApply && onFilterApply(filters);
    }
    if (key === 'clear') {
      setFilters([]);
      onClearFilter && onClearFilter();
    }
  };

  const _getAppliedFilters = () => {
    console.log(`filters`, filters);
    return (
      <>
        {filters &&
          filters?.length > 0 &&
          filters?.map((item: any, i: number) => {
            for (const [key, value] of Object.entries(item?.filters)) {
              return (
                <S.BadgeContainer
                  key={`${item?.key}-${i}`}
                  className="mx-2 h-26"
                >
                  <S.HeaderText>
                    {item?.key} <S.SearchType>{key}</S.SearchType>{' '}
                    <S.SearchValue>{value}</S.SearchValue>
                    <XCircleIcon
                      className="icon icon-xs"
                      onClick={() => {
                        onFilterRemove(item);
                      }}
                      style={{ cursor: 'pointer' }}
                    />
                  </S.HeaderText>
                </S.BadgeContainer>
              );
            }
          })}
      </>
    );
  };

  const _getSearchFilters = () => {
    return (
      <>
        {Array.isArray(tableHeaders) &&
          tableHeaders?.map((item, index) => {
            return (
              <NavDropdown
                title={item?.key}
                id={'sub-search'}
                drop={bp === 'xs' ? 'up' : 'end'}
                key={`${item?.key}-${index}`}
                onClick={() => {
                  onFilterTypeSelect(item?.key);
                  setAutoClose(false);
                }}
              >
                {_getCardInput(item?.filterTypes)}
              </NavDropdown>
            );
          })}
      </>
    );
  };
  return (
    <S.Container id={'container'} className="mb-3">
      {_getAppliedFilters()}
      <NavDropdown
        title={
          <S.AddSearch>
            <PlusIcon className="icon icon-sm" />
          </S.AddSearch>
        }
        id="search-filter"
      >
        {_getSearchFilters()}
      </NavDropdown>
      {buttons &&
        buttons?.map((item, i) => {
          return (
            <Button
              key={item?.key}
              variant={item?.variant}
              onClick={() => onButtonClick(item?.key)}
              className={'mx-2'}
              disabled={filters?.length === 0}
            >
              {item?.title}
            </Button>
          );
        })}
    </S.Container>
  );
};

SearchFilter.defaultProps = {
  // tableHeaders: [
  //   {
  //     key: "Name",
  //     filterTypes: [
  //       {
  //         id: "is",
  //         type: "text",
  //       },
  //       {
  //         id: "isNot",
  //         type: "text",
  //       },
  //       {
  //         id: "contains",
  //         type: "text",
  //       },
  //       {
  //         id: "hasAnyValue",
  //         type: "select",
  //         options: [
  //           { label: "yes", value: "yes" },
  //           { label: "no", value: "no" },
  //         ],
  //       },
  //     ],
  //   },
  //   {
  //     key: "Date Created",
  //     filterTypes: [
  //       {
  //         id: "from",
  //         type: "datePicker",
  //       },
  //       {
  //         id: "to",
  //         type: "datePicker",
  //       },
  //     ],
  //   },
  //   {
  //     key: "Verified",
  //     filterTypes: [
  //       {
  //         id: "verified",
  //         type: "select",
  //         options: [
  //           { label: "yes", value: "yes" },
  //           { label: "no", value: "no" },
  //         ],
  //       },
  //     ],
  //   },
  //   {
  //     key: "Status",
  //     filterTypes: [
  //       {
  //         id: "status",
  //         type: "select",
  //         options: [
  //           { label: "created", value: "created" },
  //           { label: "pending", value: "pending" },
  //         ],
  //       },
  //     ],
  //   },
  // ],
  buttons: [
    {
      key: 'clear',
      variant: 'light',
      title: 'Clear',
    },
    {
      key: 'apply',
      variant: 'secondary',
      title: 'Apply Filter',
    },
  ],
};
